import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../pages/shared/DashboardLayout';
import ReportsPage from '../pages/reports/ReportsPage';
import ProtectedRoute from '../auth/ProtectedRoute';
import ManagementPage from '../pages/management/ManagementPage';
import ManagementReports from '../pages/management/ManagementReports';
import ManagementDashboard from '../pages/management/ManagementDashboard';
import { ReactElement } from 'react';

// Route configuration
export const routes: AppRoute[] = [
  {
    path: '/reports',
    element: (
      <ProtectedRoute>
        <DashboardLayout>
          <ReportsPage />
        </DashboardLayout>
      </ProtectedRoute>
    ),
    label: 'Reports',
  },
  {
    path: '/management',
    element: (
      <ProtectedRoute requiredGroups={process.env.REACT_APP_MANAGEMENT_GROUP_NAME? [process.env.REACT_APP_MANAGEMENT_GROUP_NAME ] : []}>
        <DashboardLayout>
          <ManagementPage />
        </DashboardLayout>
      </ProtectedRoute>
    ),
    label: 'Management',
    requiredGroups: process.env.REACT_APP_MANAGEMENT_GROUP_NAME? [process.env.REACT_APP_MANAGEMENT_GROUP_NAME ] : [],
    children: [
      { path: '', element: <ManagementDashboard /> },
      { path: 'reports', element: <ManagementReports /> },
    ],
  },
  {
    path: '/management',
    redirect: '/management/reports',
  },
  {
    path: '*',
    redirect: '/reports',
  },
];

type AppRoute = {
  path: string;
  element?: ReactElement;
  label?: string;
  requiredGroups?: string[];
  children?: AppRoute[];
  redirect?: string;
};

function renderRoutes(routeArray: AppRoute[]): ReactElement[] {
  return routeArray.map((route, idx) => {
    if (route.redirect) {
      return <Route key={route.path || idx} path={route.path} element={<Navigate to={route.redirect} replace />} />;
    }
    return (
      <Route key={route.path || idx} path={route.path} element={route.element}>
        {route.children && renderRoutes(route.children)}
      </Route>
    );
  });
}

export const RouterProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return (
    <BrowserRouter>
      <Routes>
        {renderRoutes(routes)}
      </Routes>
      {children}
    </BrowserRouter>
  );
};

export default RouterProvider; 